import { render, staticRenderFns } from "./MapSettings.vue?vue&type=template&id=5d83ef8b"
import script from "./MapSettings.vue?vue&type=script&lang=js"
export * from "./MapSettings.vue?vue&type=script&lang=js"
import style0 from "./MapSettings.vue?vue&type=style&index=0&id=5d83ef8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports